import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { CheckCircleSvg } from './CheckCircle';

export const CheckCircleIcon = createIcon('checkCircle', CheckCircleSvg);
/**
 * @deprecated используйте CheckCircleIcon
 */
export const withCheckCircleIcon = withIcon('checkCircle', CheckCircleSvg);
